import React from 'react';
import { startCase } from 'lodash';
import { connect } from 'react-redux';
import { detect } from 'detect-browser';

import { STATIC_ROOT } from '../../../constants';
import ButtonComponent from '../../button/ButtonComponent';
import { initToolbar } from '../../../services/toolbar/actions';
import { URL_CHROME, URL_FIREFOX, URL_EDGE, URL_SAFARI } from '../../../services/toolbar/constants';

class DownloadBlock extends React.Component {
    getToolbarUrl = () => {
        const browser = detect();
        switch (browser && browser.name) {
            case 'chrome':
                return URL_CHROME;
            case 'firefox':
                return URL_FIREFOX;
            case 'edge':
                return URL_EDGE;
            case 'safari':
                return URL_SAFARI;
            default:
                return '';
        }
    };

    getBrowser = () => {
        return detect().name;
    };

    traceDownload = browser => {
        const { initToolbar } = this.props;
        initToolbar(browser);
    };

    isBrowserNotSupported = () => ['edge', 'ie'].includes(this.getBrowser());

    render() {
        const { BUTTON_TEXT, AVAILABLE } = this.props;
        return (
            <React.Fragment>
                <div className="browser">
                    {!this.isBrowserNotSupported() && (
                        <a
                            href={this.getToolbarUrl()}
                            target={this.getBrowser() !== 'ie' ? '_blank' : ''}
                            onClick={() => {
                                this.traceDownload(this.getBrowser());
                                if (window.tag) {
                                    window.tag.click.send({
                                        elem: this,
                                        name: `toolbarPage-to${startCase(this.getBrowser())}Store`,
                                        type: 'navigation'
                                    });
                                }
                            }}>
                            <ButtonComponent text={BUTTON_TEXT} color="main" />
                        </a>
                    )}
                    <div className="block">
                        <div>{AVAILABLE}</div>
                        <div className="pics">
                            <a
                                href={URL_CHROME}
                                title="Chrome"
                                target="_blank"
                                onClick={() => {
                                    this.traceDownload('chrome');
                                    if (window.tag) {
                                        window.tag.click.send({
                                            elem: this,
                                            name: 'toolbarPage-toChromeStore',
                                            type: 'navigation'
                                        });
                                    }
                                }}>
                                <img
                                    src={`${STATIC_ROOT}/toolbars/chrome_24x24.png`}
                                    alt="chrome"
                                />
                            </a>
                            <a
                                href={URL_FIREFOX}
                                title="Firefox"
                                target="_blank"
                                onClick={() => {
                                    this.traceDownload('firefox');
                                    if (window.tag) {
                                        window.tag.click.send({
                                            elem: this,
                                            name: 'toolbarPage-toFirefoxStore',
                                            type: 'navigation'
                                        });
                                    }
                                }}>
                                <img
                                    src={`${STATIC_ROOT}/toolbars/firefox_24x24.png`}
                                    alt="firefox"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        BUTTON_TEXT: state.i18n.page.TOOLBAR.BUTTON_TEXT,
        AVAILABLE: state.i18n.page.TOOLBAR.AVAILABLE
    };
};

const mapDispatchtoProps = {
    initToolbar
};

export default connect(mapStateToProps, mapDispatchtoProps)(DownloadBlock);



// WEBPACK FOOTER //
// ./src/components/pages/toolbar/DownloadBlock.js